import React from 'react';
import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-web';
import { LanguageSelectionTrigger } from '@mrkt/features/i18n/components/LanguageSelection/Trigger';
import { LanguageSelectionOnboarding } from '@mrkt/features/i18n/components/LanguageSelection/Onboarding';
import { LanguageSelectionBoundary } from '@mrkt/features/i18n/components/LanguageSelection/Boundary';
import { jsx as _jsx } from "react/jsx-runtime";
var MenuItem = styled.li.withConfig({
  displayName: "Language__MenuItem",
  componentId: "sc-157o96e-0"
})(["display:flex;align-self:center;margin:0 ", ";&:empty{display:none;}"], spacer12);
var CustomTrigger = styled(LanguageSelectionTrigger).withConfig({
  displayName: "Language__CustomTrigger",
  componentId: "sc-157o96e-1"
})(["&,&:hover,&:focus,&:focus:after{color:currentColor;border-color:currentColor;}"]);
export var NavBarLanguageItem = function NavBarLanguageItem() {
  return /*#__PURE__*/_jsx(MenuItem, {
    children: /*#__PURE__*/_jsx(LanguageSelectionBoundary, {
      fallback: null,
      children: /*#__PURE__*/_jsx(LanguageSelectionOnboarding, {
        children: /*#__PURE__*/_jsx(CustomTrigger, {
          buttonSize: "sm"
        })
      })
    })
  });
};
export var SideMenuLanguageSection = function SideMenuLanguageSection(_ref) {
  var onButtonClick = _ref.onButtonClick;
  return /*#__PURE__*/_jsx("div", {
    className: "encore-creator-dark-theme",
    children: /*#__PURE__*/_jsx(LanguageSelectionBoundary, {
      fallback: null,
      children: /*#__PURE__*/_jsx(LanguageSelectionTrigger, {
        onClick: onButtonClick
      })
    })
  });
};
export var SideMenuLanguageOnboarding = function SideMenuLanguageOnboarding(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(LanguageSelectionBoundary, {
    fallback: children,
    children: /*#__PURE__*/_jsx(LanguageSelectionOnboarding, {
      children: children
    })
  });
};